<div class="link-landing">
  <div class="link-landing-card">
    <ng-container *ngIf="loading">
      <div class="link-landing-spinner"></div>
      <h1>Opening your workflow…</h1>
      <p>Checking the link and taking you to the form.</p>
    </ng-container>

    <ng-container *ngIf="step === 'request-otp'">
      <div class="link-landing-icon link-landing-icon--brand">
        <wf-icon name="mail" [size]="22"></wf-icon>
      </div>
      <h1>Verify it’s you</h1>
      <p>
        This workflow was shared with
        <strong *ngIf="emailMasked">{{ emailMasked }}</strong>
        <span *ngIf="!emailMasked">your email address</span>.
        We’ll send a one-time code to confirm it’s you.
      </p>

      <p class="link-landing-error" *ngIf="errorMessage">{{ errorMessage }}</p>

      <button
        type="button"
        class="btn-fill link-landing-action"
        [disabled]="!canResend"
        (click)="sendCode()">
        {{ sending ? 'Sending…' : 'Send me a code' }}
      </button>
    </ng-container>

    <ng-container *ngIf="step === 'enter-code'">
      <div class="link-landing-icon link-landing-icon--brand">
        <wf-icon name="mail" [size]="22"></wf-icon>
      </div>
      <h1>Enter your code</h1>
      <p>
        We sent a 6-digit code to
        <strong *ngIf="emailMasked">{{ emailMasked }}</strong>
        <span *ngIf="!emailMasked">your email</span>. It expires in 10 minutes.
      </p>

      <div class="link-landing-code-field" [class.has-error]="errorMessage">
        <input
          class="custom-input link-landing-code"
          [type]="codeVisible ? 'text' : 'password'"
          inputmode="numeric"
          autocomplete="one-time-code"
          maxlength="6"
          placeholder="000000"
          [(ngModel)]="code"
          [disabled]="verifying"
          (input)="onCodeInput()"
          (keyup.enter)="verifyCode()" />
        <button
          type="button"
          class="link-landing-code-eye"
          [attr.aria-label]="codeVisible ? 'Hide code' : 'Show code'"
          [title]="codeVisible ? 'Hide code' : 'Show code'"
          (click)="toggleCodeVisible()">
          <wf-icon [name]="codeVisible ? 'lock' : 'eye'" [size]="16"></wf-icon>
        </button>
      </div>

      <p class="link-landing-error" *ngIf="errorMessage">
        {{ errorMessage }}
        <span *ngIf="remainingAttempts !== null && remainingAttempts > 0">
          {{ remainingAttempts }} attempt(s) remaining.
        </span>
      </p>
      <p class="link-landing-info" *ngIf="infoMessage && !errorMessage">{{ infoMessage }}</p>

      <button
        type="button"
        class="btn-fill link-landing-action"
        [disabled]="verifying || !code.trim()"
        (click)="verifyCode()">
        {{ verifying ? 'Verifying…' : 'Open my workflow' }}
      </button>

      <button
        type="button"
        class="link-landing-resend"
        [disabled]="!canResend"
        [attr.aria-live]="'polite'"
        (click)="sendCode()">
        {{ resendLabel }}
      </button>
      <p class="link-landing-resend-hint" *ngIf="resendCooldownSeconds > 0">
        Didn’t get it? Check your spam folder — you can request a new code shortly.
      </p>
    </ng-container>

    <ng-container *ngIf="step === 'error'">
      <div class="link-landing-icon">
        <wf-icon name="alert-triangle" [size]="22"></wf-icon>
      </div>
      <h1>This link can’t be opened</h1>
      <p>{{ errorMessage }}</p>
    </ng-container>
  </div>
</div>
